import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { Typography } from 'seagull';
import { useTypewriterLoop } from '../../utils/useTypewriterLoop';
import styles from './LoadingText.module.scss';
export const LoadingText = (_0)=>{
    let { children = 'Loading...', className } = _0, props = _object_without_properties(_0, [
        "children",
        "className"
    ]);
    const text = typeof children === 'string' ? children : String(children);
    const suggestions = useMemo(()=>[
            text
        ], [
        text
    ]);
    const { displayedText, opacity, duration } = useTypewriterLoop({
        disabled: false,
        value: '',
        suggestions
    });
    return /*#__PURE__*/ _jsx(motion.div, {
        animate: {
            opacity
        },
        transition: {
            duration
        },
        className: classNames(styles.loadingText, className),
        children: /*#__PURE__*/ _jsx(Typography, _object_spread_props(_object_spread({}, props), {
            children: displayedText
        }))
    });
};
